// extracted by mini-css-extract-plugin
module.exports = {"background":"ServiceGrid_background__3ULK6","heading":"ServiceGrid_heading__2kZ1k","guidegrid":"ServiceGrid_guidegrid__3P-YF"};